module.exports = __webpack_public_path__ + "img/people.35f8b7c8.svg";